import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.css']
})
export class CreditCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    $(document).ready(function() {
          
      $('.input-cart-number').on('keyup change', function(){
        
        // if ($(this).val().length > 3) {
        if ($(this).val() > 4) {
          $(this).next().focus();
        }
        
        var card_number = '';
        $('.input-cart-number').each(function(){
          card_number += $(this).val() + ' ';
          // if ($(this).val().length == 4) {
          if ($(this).val() == 4) {
            $(this).next().focus();
          }
        })
        
        $('.credit-card-box .number').html(card_number);
      });
      
      $('#card-holder').on('keyup change', function(){
        var card_number = '';
        card_number = $(this).val().toString();        
        $('.credit-card-box .card-holder div').html(card_number);
      });
      
      $('#card-holder').on('keyup change', function() {
        var card_number = '';
        card_number = $(this).val().toString();                
        $('.credit-card-box .card-holder div').html(card_number);
      });
      
      $('#card-expiration-month, #card-expiration-year').change(function(){
        var m;
        var y;
        m = $('#card-expiration-month option').index($('#card-expiration-month option:selected'));
        m = (m < 10) ? '0' + m : m;
        y = $('#card-expiration-year').val().toString().substr(2,2);
        $('.card-expiration-date div').html(m + '/' + y);
      })
      
      $('#card-ccv').on('focus', function(){
        $('.credit-card-box').addClass('hover');
      }).on('blur', function(){
        $('.credit-card-box').removeClass('hover');
      }).on('keyup change', function(){
        $('.ccv div').html($(this).val().toString());
      });
      
      
      /*--------------------
       Tile Preview
      --------------------*/
      setTimeout(function(){
        $('#card-ccv').focus().delay(2000).queue(function(){
          $(this).blur().dequeue();
        });
      }, 500);
      
      //identifica qual a bandeira do cartão pelo número
      function getCreditCardType(accountNumber) {
        var result = 'unknown'        
        if (/^5[1-5]/.test(accountNumber)) {
          result = 'mastercard';
        } else if (/^4/.test(accountNumber)) {
          result = 'visa';
        } else if ( /^(5018|5020|5038|6304|6759|676[1-3])/.test(accountNumber)) {
          result = 'maestro';
        }
        return result;
      }
      
      //exibe a bandeira
      $('#card-number').change(function(){
        console.log(getCreditCardType($(this).val()));
      })
    });
  }

}
